import { api } from '@/api/client'
import { usePolling } from '@/lib/usePolling'
import type { Run } from '@/api/types'

const TERMINAL: ReadonlySet<Run['status']> = new Set(['succeeded', 'failed'])

export interface RunPollingState {
  run: Run | null
  error: string | null
  /** True while the run is still moving; false once it reached a terminal state. */
  polling: boolean
}

/**
 * Polls GET /api/v1/runs/{id} until the run reaches a terminal state.
 *
 * The loop itself is `usePolling` — the same one the BZO ingestion view uses,
 * so "no frozen spinner" is one behaviour with one set of edge cases rather
 * than two hand-copied ones that drift.
 */
export function useRunPolling(runId: string | null, initial: Run | null = null): RunPollingState {
  const { data, error, polling } = usePolling<Run>(
    runId,
    (signal) => api.run(runId as string, signal),
    (run) => TERMINAL.has(run.status),
    initial,
  )
  return { run: data, error, polling }
}
